import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import translate from "../../i18n/translate";
import ApiRequest from "../../actions/ApiRequest";

const WelcomePageModal = ({ open, onClose, content }) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleOK = async () => {
    if (dontShowAgain) {
      try {
        await ApiRequest.post(`welcome_page?operation=hide&dont_show_again=true`);
        localStorage.setItem("welcome_page_hidden", "true");
      } catch (error) {
        console.error("Failed to save welcome page preference:", error);
      }
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
        },
      }}
    >
      <DialogTitle
        sx={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          padding: 2.5,
          textAlign: "center",
        }}
      >
        <Typography variant="h5" component="div" sx={{ fontWeight: 600 }}>
          {translate("Welcome")}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: 3 }}>
        <Box
          sx={{
            padding: 2,
            backgroundColor: "#f8f9fa",
            borderRadius: 2,
            minHeight: 150,
            maxHeight: 400,
            overflowY: "auto",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              whiteSpace: "pre-wrap",
              lineHeight: 1.8,
              color: "#333",
              fontSize: "1rem",
            }}
          >
            {content}
          </Typography>
        </Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
              color="primary"
            />
          }
          label={translate("Don't show this again")}
          sx={{ marginTop: 2 }}
        />
      </DialogContent>
      <DialogActions sx={{ padding: 2, justifyContent: "center" }}>
        <Button
          onClick={handleOK}
          variant="contained"
          color="primary"
          sx={{
            minWidth: 120,
            padding: "10px 24px",
            borderRadius: 2,
            textTransform: "none",
            fontSize: "1rem",
            fontWeight: 600,
          }}
        >
          {translate("OK")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WelcomePageModal;

